import {createApp} from "vue";
import {createPinia} from "pinia";
import SalaryOverviewApp from "./App/SalaryOverviewApp.vue";

const pinia = createPinia();

const el = document.getElementById("salary-overview-app");
if (el) {
    createApp(SalaryOverviewApp, {
        statisticsHeading: el.dataset.statisticsHeading ?? null,
        statisticsDescription: el.dataset.statisticsDescription ?? null,
        explanationLinkLabel: el.dataset.explanationLinkLabel ?? null,
        explanationLinkUrl: el.dataset.explanationLinkUrl ?? null,
    }).use(pinia).mount(el);
}
